import React from 'react';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import WebPlayerNew from './webPlayer/WebPlayer';

/**
 * Componente per effettuare test in fase di sviluppo su una rotta `/test-components/current`
 *
 * @description NON COMMITTARE le modifiche. Usarlo solo per testare componenti singolarmente.
 *
 * @constructor
 */
const TestComponentsNewPlayer = () => {
  return (
    <div style={{ maxWidth: '1600px' }}>
      <Paper>
        <Box p={2} mb={3}>
          {/* e06 con heading <WebPlayerNew currentDrill={0} sessionId="105053" teamId="661" templateId="3321" /> */}
          {/* e15 <WebPlayerNew currentDrill={null} sessionId="107358" teamId="438" templateId="2036" /> */}
          {/* master <WebPlayerNew currentDrill={1} sessionId="56839" teamId="397" templateId="1570" /> */}
          {/* master <WebPlayerNew currentDrill={null} sessionId="62003" teamId="397" templateId="1570" /> */}
          {/* master <WebPlayerNew currentDrill={null} sessionId="37853" teamId="119" templateId="260" /> */}

          <WebPlayerNew currentDrill={null} sessionId="62003" teamId="397" templateId="1570" />
        </Box>
      </Paper>
    </div>
  );
};

export default TestComponentsNewPlayer;
